<!--
  Иконка участников: группа пользователей.
  Обычно используется в блоках контрагентов, участников и ответственных лиц.
-->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M16 21V19C16 16.7909 14.2091 15 12 15H6C3.79086 15 2 16.7909 2 19V21"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
    />
    <circle
      cx="9"
      cy="7"
      r="4"
      :stroke="stroke"
      stroke-width="2"
    />
    <path
      d="M22 21V19C22 17.1362 20.7252 15.5701 19 15.126M16 3.126C17.7252 3.56985 19 5.13616 19 7C19 8.86384 17.7252 10.4301 16 10.874"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  name: "ParticipantsIcon",

  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    stroke: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
